import { render, staticRenderFns } from "./ChapterManager.vue?vue&type=template&id=7c74e9f4&scoped=true&"
import script from "./ChapterManager.vue?vue&type=script&lang=js&"
export * from "./ChapterManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c74e9f4",
  null
  
)

export default component.exports